import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import AdminLayout from './AdminLayout';
import supabase from '../../supabase/supabase';

const { FiDollarSign, FiShoppingBag, FiPackage, FiTrendingUp, FiInbox, FiUsers, FiTruck, FiRotateCcw, FiXCircle } = FiIcons;

function AdminDashboard() {
  const [stats, setStats] = useState({ orders: 0, revenue: 0, products: 0, customers: 0 });
  const [refundStats, setRefundStats] = useState({ count: 0, amount: 0, cancellations: 0 });
  const [recentOrders, setRecentOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      const [{ data: orders }, { count: orderCount }, { count: productCount }, { count: custCount }] = await Promise.all([
        supabase.from('orders_1750000001').select('*').order('created_at', { ascending: false }).limit(5),
        supabase.from('orders_1750000001').select('*', { count: 'exact', head: true }),
        supabase.from('products_1750000001').select('*', { count: 'exact', head: true }),
        supabase.from('customers_1750000002').select('*', { count: 'exact', head: true })
      ]);

      const totalRevenue = (orders || []).reduce((sum, o) => sum + Number(o.total_amount || 0), 0);
      setStats({
        orders: orderCount || 0,
        revenue: totalRevenue,
        products: productCount || 0,
        customers: custCount || 0
      });

      const { data: orderStats } = await supabase
        .from('orders_1750000001')
        .select('status,total_amount,refund_amount');

      const refunded = (orderStats || []).filter((order) => order.status === 'refunded');
      setRefundStats({
        count: refunded.length,
        amount: refunded.reduce((sum, order) => sum + Number(order.refund_amount || order.total_amount || 0), 0),
        cancellations: (orderStats || []).filter((order) => order.status === 'cancelled').length
      });
      setRecentOrders(orders || []);
      setLoading(false);
    };
    load();
  }, []);

  const statCards = [
    { icon: FiDollarSign, color: '#0e8f5b', bg: '#eaf7f1', label: 'Revenue', value: `Rs. ${stats.revenue.toLocaleString()}` },
    { icon: FiShoppingBag, color: '#3b82f6', bg: '#eff6ff', label: 'Orders', value: stats.orders },
    { icon: FiPackage, color: '#8b5cf6', bg: '#f5f3ff', label: 'Products', value: stats.products },
    { icon: FiUsers, color: '#d97706', bg: '#fffbeb', label: 'Customers', value: stats.customers },
    { icon: FiRotateCcw, color: '#dc2626', bg: '#fef2f2', label: 'Total Refunds', value: refundStats.count },
    { icon: FiDollarSign, color: '#dc2626', bg: '#fff1f2', label: 'Refund Amount', value: `Rs. ${refundStats.amount.toLocaleString()}` },
    { icon: FiXCircle, color: '#92400e', bg: '#fffbeb', label: 'Cancellations', value: refundStats.cancellations }
  ];

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1>Dashboard</h1>
          <p>Overview of your store performance</p>
        </div>
      </div>
      <div className="admin-stats">
        {statCards.map(({ icon, color, bg, label, value }) => (
          <div className="admin-stat-card" key={label}>
            <div className="stat-icon" style={{ color, background: bg }}><SafeIcon icon={icon} /></div>
            <div className="stat-info">
              <div className="stat-value">{value}</div>
              <div className="stat-label">{label}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="admin-card">
        <div className="admin-card-header">
          <h2>Recent Orders</h2>
        </div>
        {loading ? (
          <div className="admin-loading">Loading…</div>
        ) : recentOrders.length === 0 ? (
          <div className="admin-empty"><SafeIcon icon={FiInbox} /><p>No orders yet</p></div>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr><th>Order</th><th>Customer</th><th>Amount</th><th>Status</th><th>Date</th></tr>
              </thead>
              <tbody>
                {recentOrders.map((order) => (
                  <tr key={order.id}>
                    <td className="mono">{order.id.slice(0, 8)}…</td>
                    <td>{order.customer_name}</td>
                    <td>Rs. {Number(order.total_amount).toLocaleString()}</td>
                    <td><span className={`status-badge ${order.status}`}>{order.status}</span></td>
                    <td>{new Date(order.created_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}

export default AdminDashboard;